import React from 'react';
import {useFormValidation} from './useFormValidation';
import {ValidationFieldName, ValidationResult} from "../component/ValidationComponent";

export type FormContext<T> = {
    errorMessages: string[],
    formState: FormState
    updateValidationStatus: (status: ValidationResult<T>) => void,
    formDisabled: boolean,
    getMessage: (fieldName: ValidationFieldName<T>) => string | undefined;
    onSubmitClick: () => void;
    setFormState: (formState: FormState) => void
    removeErrorByFieldName: (fieldName: ValidationFieldName<T>) => void
};

export interface ValidatedFormProps<T> {
    submitForm: () => void;
    children: (context: FormContext<T>) => JSX.Element[] | JSX.Element;
}

export type FormState = {
    formDisabled: boolean,
    formDirty: boolean
}

export const ValidatedForm = <T extends any>({
                                                 submitForm,
                                                 children
                                             }: ValidatedFormProps<T>) => {
    const formValidation = useFormValidation<T>({submitForm});
    return <>
        {children(formValidation)}
    </>
}
